import { AccessRightType } from '@fi-shared/types';
import { IFiUserModuleAccessRights } from '@fi-shared/fi-shared-services/fi-user-data.service';

export function fiHasAccessToApplicationType(
    applicationSettingType,
    accessLevel: AccessRightType,
    moduleAccessRights: IFiUserModuleAccessRights,
) {
    return (moduleAccessRights.AppSettingsRights || []).some((item) => {
        return item.ApplicationSettingType == applicationSettingType && item.AccessRightType >= accessLevel;
    });
}
